import { useStressAssessmentUserResult } from './hooks';
import { getBreadcrumbItems } from './logics/breadcrumb';
import { convertToPresentationProps } from './logics/convertToPresentationProps';
import { StressAssessmentUserResultPresentation } from './presentations';

type Props = {
  stressAssessmentId: string;
  userId: number;
};

export const StressAssessmentUserResult: React.FC<Props> = ({ stressAssessmentId, userId }) => {
  const { result, answers, categories, selectedTab, handleTabChange } =
    useStressAssessmentUserResult(Number(stressAssessmentId), userId);

  const {
    userName,
    result: resultData,
    answers: answersData,
    categories: categoriesData,
  } = convertToPresentationProps({
    result,
    answers,
    categories,
  });

  const breadcrumbItems = getBreadcrumbItems(
    stressAssessmentId,
    resultData.stress_assessment.title,
    userName
  );

  return (
    <StressAssessmentUserResultPresentation
      stressAssessmentId={stressAssessmentId}
      userName={userName}
      breadcrumbItems={breadcrumbItems}
      selectedTab={selectedTab}
      onTabChange={handleTabChange}
      result={resultData}
      answers={answersData}
      categories={categoriesData}
    />
  );
};
